import '../styles/globals.css'
import { Hero } from "@/components/hero"
import { GameGrid } from "@/components/game-grid"
import LightRays from "@/components/light-rays"

export function App() {
  return (
    <main className="min-h-screen bg-background selection:bg-primary selection:text-primary-foreground">
      {/* Light rays top background decoration */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1,
          pointerEvents: "none",
        }}
      >
        <LightRays
          raysOrigin="top-center"
          raysColor="#ffffff"
          raysSpeed={1.5}
          lightSpread={0.8}
          rayLength={1.2}
          followMouse={true}
          mouseInfluence={0.1}
          noiseAmount={0.1}
          distortion={0.05}
          className="custom-rays"
        />
      </div>
      {/* Main hero and grid content */}
      <Hero />
      <GameGrid />
    </main>
  );
}

export default App;
